<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-5">
          <h1 class="mt-5">My Pre-Filters</h1>
          <div *ngIf="loadingData">
            <i class="fas fa-spinner fa-pulse"></i> Loading Pre-Filters, Please Wait...
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-5" *ngIf="!loadingData">
          <mat-select [(ngModel)]="selectedSubscription" (selectionChange)="subscriptionChanged($event)">
            <mat-option *ngFor="let subscription of subscriptions" [value]="subscription">{{subscription.subscriptionName}} - {{subscription.organizationName}}</mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <pre-filter-management [subscriptionId]="selectedSubscriptionId"></pre-filter-management>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
